if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    getIncrement(item) {
      if (!item) return 1;
      if (item.product_type === 'Bone China') return 3;
      if (item.product_type === 'Magnet') return 6;
      if (item.product_type === 'Greeting & Note Cards' || item.product_type === 'Greeting Card' || item.product_type === 'Coaster') return 6;
      if (item.product_type === 'Christmas Decoration' || item.product_type === 'Chopping Board') return 6;
      if (item.product_type === 'Trinket Tray') return 3;
      if (/Greeting Card|Coaster Card|Coaster/i.test(item.product_title || item.title || '')) return 6;
      return 1;
    }
    normalizeAddedQuantities(response) {
      if (!response || !Array.isArray(response.items)) return Promise.resolve(response);
      const updates = {};
      response.items.forEach((item) => {
        const increment = this.getIncrement(item);
        if (increment > 1 && item.quantity > 0 && item.quantity % increment !== 0) {
          updates[item.key] = Math.max(increment, Math.ceil(item.quantity / increment) * increment);
        }
      });
      if (!Object.keys(updates).length) return Promise.resolve(response);
      const config = fetchConfig('javascript');
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify({ updates, sections: this.cart.getSectionsToRender().map((section) => section.id), sections_url: window.location.pathname });
      return fetch(`${routes.cart_update_url}`, config).then((res) => res.json());
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          return this.normalizeAddedQuantities(response);
        })
        .then((normalizedResponse) => {
          if (!normalizedResponse || this.error) return;
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => { setTimeout(() => { this.cart.renderContents(normalizedResponse); }); }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(normalizedResponse);
          }
        })
        .catch((e) => { console.error(e); })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
